Object.defineProperty(exports, "__esModule", {
    value: true
});
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var require_utils = require('./utils.cjs');
var require_parser = require('./parser.cjs');
var require_compare = require('./compare.cjs');
//#region src/utils/semver/index.ts
function parseComparatorString(range) {
    return require_utils.pipe(require_parser.parseCarets, require_parser.parseTildes, require_parser.parseXRanges, require_parser.parseStar)(range);
}
function parseRange(range) {
    return require_utils.pipe(require_parser.parseHyphen, require_parser.parseComparatorTrim, require_parser.parseTildeTrim, require_parser.parseCaretTrim)(range.trim()).split(/\s+/).join(" ");
}
function satisfy(version, range) {
    if (!version) return false;
    var extractedVersion = require_utils.extractComparator(version);
    if (!extractedVersion) return false;
    var _extractedVersion = _sliced_to_array._(extractedVersion, 7), versionOperator = _extractedVersion[1], versionMajor = _extractedVersion[3], versionMinor = _extractedVersion[4], versionPatch = _extractedVersion[5], versionPreRelease = _extractedVersion[6];
    var versionAtom = {
        operator: versionOperator,
        version: require_utils.combineVersion(versionMajor, versionMinor, versionPatch, versionPreRelease),
        major: versionMajor,
        minor: versionMinor,
        patch: versionPatch,
        preRelease: versionPreRelease === null || versionPreRelease === void 0 ? void 0 : versionPreRelease.split(".")
    };
    var orRanges = range.split("||");
    for (var orRange of orRanges){
        var trimmedOrRange = orRange.trim();
        if (!trimmedOrRange) return true;
        if (trimmedOrRange === "*" || trimmedOrRange === "x") return true;
        try {
            var parsedSubRange = parseRange(trimmedOrRange);
            if (!parsedSubRange.trim()) return true;
            var parsedComparatorString = parsedSubRange.split(" ").map((rangeVersion)=>parseComparatorString(rangeVersion)).join(" ");
            if (!parsedComparatorString.trim()) return true;
            var comparators = parsedComparatorString.split(/\s+/).map((comparator)=>require_parser.parseGTE0(comparator)).filter(Boolean);
            if (comparators.length === 0) continue;
            var subRangeSatisfied = true;
            for (var comparator of comparators){
                var extractedComparator = require_utils.extractComparator(comparator);
                if (!extractedComparator) {
                    subRangeSatisfied = false;
                    break;
                }
                var _extractedComparator = _sliced_to_array._(extractedComparator, 7), rangeOperator = _extractedComparator[1], rangeMajor = _extractedComparator[3], rangeMinor = _extractedComparator[4], rangePatch = _extractedComparator[5], rangePreRelease = _extractedComparator[6];
                if (!require_compare.compare({
                    operator: rangeOperator,
                    version: require_utils.combineVersion(rangeMajor, rangeMinor, rangePatch, rangePreRelease),
                    major: rangeMajor,
                    minor: rangeMinor,
                    patch: rangePatch,
                    preRelease: rangePreRelease === null || rangePreRelease === void 0 ? void 0 : rangePreRelease.split(".")
                }, versionAtom)) {
                    subRangeSatisfied = false;
                    break;
                }
            }
            if (subRangeSatisfied) return true;
        } catch (e) {
            console.error(`[semver] Error processing range part "${trimmedOrRange}":`, e);
            continue;
        }
    }
    return false;
}
//#endregion
exports.satisfy = satisfy; //# sourceMappingURL=index.cjs.map
